import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await register(form.name, form.email, form.password);
    setLoading(false);
    if (res.ok) navigate("/account"); else setError(res.error);
  };

  return (
    <div className="container-furn flex min-h-[70vh] items-center justify-center py-16">
      <div className="w-full max-w-md border border-border bg-card p-8">
        <div className="mb-8 flex justify-center"><Logo /></div>
        <h1 className="mb-1 font-display text-2xl font-semibold uppercase">Create Account</h1>
        <p className="mb-6 text-sm text-muted-foreground">Join Furn Angling & start earning loyalty points.</p>
        {error && <div data-testid="register-error" className="mb-4 border border-destructive/50 bg-destructive/10 px-3 py-2 text-sm text-destructive">{error}</div>}
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="register-name" placeholder="Full name" value={form.name} onChange={set("name")} required className="w-full border border-border bg-secondary/60 px-3 py-3 text-sm outline-none focus:border-accent transition-colors" />
          <input data-testid="register-email" type="email" placeholder="Email" value={form.email} onChange={set("email")} required className="w-full border border-border bg-secondary/60 px-3 py-3 text-sm outline-none focus:border-accent transition-colors" />
          <input data-testid="register-password" type="password" placeholder="Password" value={form.password} onChange={set("password")} required minLength={6} className="w-full border border-border bg-secondary/60 px-3 py-3 text-sm outline-none focus:border-accent transition-colors" />
          <button data-testid="register-submit" disabled={loading} className="w-full bg-accent py-3.5 text-xs font-bold uppercase tracking-widest text-accent-foreground hover:brightness-110 transition-[filter] disabled:opacity-50">{loading ? "Creating…" : "Create Account"}</button>
        </form>
        <p className="mt-6 text-center text-sm text-muted-foreground">Already have an account? <Link to="/login" className="font-semibold text-accent">Sign in</Link></p>
      </div>
    </div>
  );
}
